import { render } from "./ConfirmedReplacementOrder.vue?vue&type=template&id=51774ba6"
import script from "./ConfirmedReplacementOrder.vue?vue&type=script&lang=js"
export * from "./ConfirmedReplacementOrder.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__